/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import ReadOnlySocialMedia from './ReadOnlySocialMedia';
import Classes from '../common/Classes';
import Utils from '../common/Utils';
import CopyComponent from '../common/components/CopyComponent';
import MixPanelHelper from '../common/MixPanelHelper';
import { MixpanelEventName } from '../common/Constants';

class ParticipantContact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEmailToolTip: false, showPhoneToolTip: false
    };
  }

  setPhoneText = (showContactInformationOverride, unavailable, phone) => {
    const phoneText = !showContactInformationOverride ? unavailable : (phone || '').trim();
    return phoneText;
  };

  setTextColor = (showContactInformationOverride) => {
    const textColor = showContactInformationOverride ? Classes.themeColor : Classes.greyedOut;
    return textColor;
  };

  setShowCopyToClipboard = (isEditMode, showContactInformationOverride) => !isEditMode && showContactInformationOverride;

  handleEmailCopyClick = (participantId) => {
    this.setState({ showEmailToolTip: true, showPhoneToolTip: false });
    setTimeout(() => {
      this.setState({ showEmailToolTip: false });
    }, 2000);
    MixPanelHelper.trackInteractedEvents(MixpanelEventName.ContactInfoInteracted, participantId, 'Email_Copy');
  };

  handlePhoneCopyClick = (participantId) => {
    this.setState({ showPhoneToolTip: true, showEmailToolTip: false });
    setTimeout(() => {
      this.setState({ showPhoneToolTip: false });
    }, 2000);
    MixPanelHelper.trackInteractedEvents(MixpanelEventName.ContactInfoInteracted, participantId, 'Phone_Copy');
  };

  handleClick = (eventName, participantId, interactedElement) => {
    MixPanelHelper.trackInteractedEvents(eventName, participantId, interactedElement);
  };

  renderEmailTextSection = (showContactInformationOverride, unavailable, email, isEditMode, participantId) => {
    if (!showContactInformationOverride) {
      return (
        <span aria-label="Email unavailable">{unavailable}</span>
      );
    }
    const emailTrimmed = email.trim();
    if (isEditMode) {
      return (
        <a
          href={`mailto:${emailTrimmed}`}
          tabIndex={0}
          aria-label={`send email to ${emailTrimmed}`}
        >
          {emailTrimmed}
        </a>
      );
    }
    return (
      <a
        href={`mailto:${emailTrimmed}`}
        tabIndex={0}
        aria-label={`Send email to ${emailTrimmed}`}
        onClick={() => this.handleClick(MixpanelEventName.ContactInfoInteracted, participantId, 'Email_Click')}
      >
        {emailTrimmed}
      </a>
    );
  };

  renderSocialIconsReadOnlySection = (showSocialIcons, allSocialMedia, contact, participantId) => {
    const socialIcons = showSocialIcons ? (
      <li className={contact.item}>
        <hr />
        {/* <div className={contact.label}>{props.translations.socialLabel}</div> */}
        <ReadOnlySocialMedia
          tag={this.props.tags.socialMedia}
          translations={this.props.translations.socialMedia}
          socialMedia={allSocialMedia}
          participantId={participantId}
        />
      </li>
    ) : null;
    return socialIcons;
  };

  render() {
    const profileClass = Classes.homePage.participantProfile;
    const { contact } = profileClass;
    const {
      isEditMode,
      isDefaultLocale,
      hideContactDetailsAdmin,
      participantId
    } = this.props;
    const {
      email,
      phone,
      showContactInformation,
      socialMedia
    } = this.props.data;

    const showContactInformationOverride = !hideContactDetailsAdmin && showContactInformation;

    const {
      unavailable, emailCopyTooltip, phoneCopyTooltip, copiedTooltip
    } = this.props.translations;

    const isPhoneInitialised = (phone || '').length > 0;
    const phoneText = this.setPhoneText(showContactInformationOverride, unavailable, phone);
    const textColor = this.setTextColor(showContactInformationOverride);
    let allSocialMedia = Utils.getMergedSocialMedia(socialMedia);
    allSocialMedia = this.props.showAllSocialMedia ? allSocialMedia : allSocialMedia.filter((sm) => sm.url.length > 0);
    const showSocialIcons = this.props.showAllSocialMedia || allSocialMedia.length > 0;
    const showCopyToClipboard = this.setShowCopyToClipboard(isEditMode, showContactInformationOverride);
    return (
      <div data-testid="participant-contact" className={this.props.className}>
        {isDefaultLocale ? null : this.props.children}
        <ul className={contact.items}>
          <li className={`${contact.item} ${textColor}`}>
            <div className={contact.email} />
            <div
              className={`${contact.value} ${contact.colored}`}
              data-dtm={this.props.tags.email}
            >
              {this.renderEmailTextSection(showContactInformationOverride, unavailable, email, isEditMode, participantId)}
            </div>
            {showCopyToClipboard
              && (
              <CopyComponent
                text={email.trim()}
                className={contact.copy}
                dtmTagName={this.props.tags.emailCopy}
                toolTipHoverText={emailCopyTooltip}
                toolTipClickText={copiedTooltip}
                iconClass={contact.clipBoard}
                handleClick={() => this.handleEmailCopyClick(participantId)}
                showToolTip={this.state.showEmailToolTip}
              />
              )}
          </li>
          {isPhoneInitialised
            && (
            <li className={`${contact.item} ${textColor}`}>
              <div className={contact.phone} />
              <div
                className={`${contact.value} ${contact.colored}`}
                data-dtm={this.props.tags.phone}
              >
                <a
                  href={`tel:${phoneText}`}
                  onClick={() => this.handleClick(MixpanelEventName.ContactInfoInteracted, participantId, 'Phone_Click')}
                >
                  {phoneText}
                </a>
              </div>
              {showCopyToClipboard
              && (
              <CopyComponent
                text={phoneText.trim()}
                className={contact.copy}
                dtmTagName={this.props.tags.phoneCopy}
                toolTipHoverText={phoneCopyTooltip}
                toolTipClickText={copiedTooltip}
                iconClass={contact.clipBoard}
                handleClick={() => this.handlePhoneCopyClick(participantId)}
                showToolTip={this.state.showPhoneToolTip}
              />
              )}
            </li>
            )}
          {this.renderSocialIconsReadOnlySection(showSocialIcons, allSocialMedia, contact, participantId)}
        </ul>
      </div>
    );
  }
}

ParticipantContact.propTypes = {
  className: PropTypes.string,
  translations: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  tags: PropTypes.object.isRequired,
  showAllSocialMedia: PropTypes.bool,
  isEditMode: PropTypes.bool,
  isDefaultLocale: PropTypes.bool,
  children: PropTypes.object,
  hideContactDetailsAdmin: PropTypes.bool.isRequired,
  participantId: PropTypes.string
};

export default ParticipantContact;
